import { getCookie, setCookie } from './_cookie';

export function infoTriangle() {
  const infoTriangle = document.querySelector('.info-triangle');
  if (!infoTriangle) return;

  const cookieName = infoTriangle.getAttribute('data-cookie-name') || 'po-web-triangle';
  const cook = getCookie(cookieName);
  if (cook == null || cook == 0) {
    setTimeout(function () {
      document.body.classList.add('is-info-triangle-active');
    }, 1000);
  }

  const infoTriggerClose = document.querySelector('.js-info-triangle-close');
  if (infoTriggerClose) {
    infoTriggerClose.addEventListener('click', function (e) {
      e.preventDefault();
      const cookieDays = parseFloat(infoTriggerClose.getAttribute('data-cookie-days') || '3');
      const maxAge = cookieDays > 0 ? Math.round(cookieDays * 86400) : undefined;
      setCookie(cookieName, '1', maxAge);
      document.body.classList.remove('is-info-triangle-active');
    });
  }
}
